import { PartnersService } from "~/entity/Partners/api/service";
import { IPartnersListParams } from "~/entity/Partners/model/schema";

export const usePartners = () => {
  const queryKeys = {
    all: [PartnersService._routes.partners],
    list: (params: IPartnersListParams) => [
      PartnersService._routes.partners,
      params,
    ],
    byId: (id?: string) => [PartnersService._routes.partners, id],
  };

  const getPartnersList = PartnersService.GET.list;
  const getPartnerById = PartnersService.GET.byId;
  const createPartner = PartnersService.POST.create;
  const updatePartner = PartnersService.PUT.update;
  const deletePartner = (id: string) =>
    PartnersService.PUT.update(id, { status: "ARCHIVED" });

  return {
    queryKeys,
    getPartnersList,
    getPartnerById,
    createPartner,
    updatePartner,
    deletePartner,
  };
};
